import {
  AfterContentInit,
  Component, ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  TemplateRef
} from '@angular/core';
import { CapturumTemplateDirective } from '@capturum/ui/api';

@Component({
  selector: 'cap-card',
  templateUrl: './card.component.html'
})
export class CardComponent implements AfterContentInit {
  /**
   * The title of the card to be displayed in the card header
   */
  @Input()
  public title: string;
  /**
   * The text to be displayed in the header button
   */
  @Input()
  public buttonLabel: string;
  /**
   * The icon class of the icon in the button at the card header
   */
  @Input()
  public buttonIcon: string;
  /**
   * When enabled it will display an icon with three vertical dots at the top right of the card
   */
  @Input()
  public settings: boolean;
  /**
   * The template to be displayed as the card header
   */
  @Input()
  public cardHeaderTemplate: TemplateRef<string>;
  /**
   * The template to be displayed as the card content
   */
  @Input()
  public cardContentTemplate: TemplateRef<string>;
  /**
   * Add a custom css class to the card
   */
  @Input() public styleClass: string;

  /**
   * Callback to invoke when the button in the card header is clicked
   */
  @Output()
  public buttonClick: EventEmitter<void> = new EventEmitter();
  /**
   * Callback to invoke when the settings button in the card header is clicked
   */
  @Output()
  public settingClick: EventEmitter<void> = new EventEmitter();

  @ContentChildren(CapturumTemplateDirective)
  public templates: QueryList<CapturumTemplateDirective>;

  public get isEmptyHeader(): boolean {
    return !this.title && !this.cardHeaderTemplate;
  }

  public ngAfterContentInit(): void {
    this.templates.forEach((template) => {
      switch (template.getType()) {
        case 'content':
          this.cardContentTemplate = template.template;
          break;
        case 'header':
          this.cardHeaderTemplate = template.template;
          break;
      }
    });
  }
}
